<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增管理</el-breadcrumb-item>
      <el-breadcrumb-item>采购管理</el-breadcrumb-item>
      <el-breadcrumb-item>采购交货</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.purchasecompany" @keyup.enter.native="clickSearch" placeholder="请输入采购单位"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.projectname" @keyup.enter.native="clickSearch" placeholder="请输入项目名称"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.bomname" @keyup.enter.native="clickSearch" placeholder="请输入物料名称"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.bomsn" @keyup.enter.native="clickSearch" placeholder="请输入物料编码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border :cell-style="{padding: '0'}" height="440">
          <el-table-column type="expand" min-width="1%">
            <template slot-scope="props">
              <el-table :data="props.row.Sublist" height="300" class="tableInner" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center',padding: '0' }">
                <el-table-column prop="Num" label="交货数量" width="200"></el-table-column>
                <el-table-column prop="Createtime" label="交货时间" width="200"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="Orderid" label="合同编号" width="200"></el-table-column>
          <el-table-column prop="Suppliername" label="供应商名称" width="300"></el-table-column>
          <el-table-column prop="Createtime" label="采购时间" width="300"></el-table-column>
          <el-table-column prop="Projectname" label="项目名称" width="300"></el-table-column>
          <el-table-column prop="Bomname" label="物料名称" width="300"></el-table-column>
          <el-table-column prop="Purchasecompany" label="采购单位" width="300"></el-table-column>
          <el-table-column prop="Contractamount" label="合同金额" width="100"></el-table-column>
          <el-table-column prop="Contractnum" label="合同数量" width="100"></el-table-column>
          <el-table-column prop="DeliveryNum" label="已交货总数量" width="200"></el-table-column>
          <el-table-column prop="operation" label="操作" width="200" fixed="right">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDelivery(scope.row)">交货</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 交货 start -->
        <el-dialog title="交货" :visible.sync="dialogDelivery" width="600px">
          <el-form :model="modelDelivery" ref="addMechanismRef" label-width="150px">
            <el-form-item label="本次交货数量" class="addAdminForm">
              <el-input v-model="modelDelivery.num" placeholder="请输入本次交货数量"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="apiAddErp6PurchaseOrderDelivery">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 交货 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->
  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyErp6PurchaseOrderDelivery',
  data () {
    return {
      activeName: 'first',
      modelDelivery: {
        orderid: '',
        num: '0'
      },
      keywords: {
        begintime: '',
        endtime: '',
        purchasecompany: '',
        projectname: '',
        bomname: '',
        bomsn: '',
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogDelivery: false
    }
  },
  mounted () {
    this.apiGetErp6PurchaseOrderDeliveryNum()
    this.apiGetErp6PurchaseOrderDeliveryList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetErp6PurchaseOrderDeliveryNum()
      this.apiGetErp6PurchaseOrderDeliveryList()
    },
    clickDelivery (row) {
      this.dialogDelivery = true
      this.modelDelivery.orderid = row.Orderid
      this.modelDelivery.num = 0
    },
    clickReturn () {
      this.activeName = 'first'
    },
    clickSearch () {
      this.selectedPageNo = 1
      this.apiGetErp6PurchaseOrderDeliveryNum()
      this.apiGetErp6PurchaseOrderDeliveryList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp6PurchaseOrderDeliveryList()
    },
    apiGetErp6PurchaseOrderDeliveryNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        purchasecompany: that.keywords.purchasecompany,
        projectname: that.keywords.projectname,
        bomname: that.keywords.bomname,
        bomsn: that.keywords.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6PurchaseOrderDeliveryNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp6PurchaseOrderDeliveryList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        purchasecompany: that.keywords.purchasecompany,
        projectname: that.keywords.projectname,
        bomname: that.keywords.bomname,
        bomsn: that.keywords.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6PurchaseOrderDeliveryList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddErp6PurchaseOrderDelivery: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.modelDelivery.orderid,
        num: that.modelDelivery.num
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddErp6PurchaseOrderDelivery, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6PurchaseOrderDeliveryNum()
            that.apiGetErp6PurchaseOrderDeliveryList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

</style>
